export const tableCellDefined = [
  {
    id: 'created_datetime',
    name: "建立時間",
    align: 'center',
    type: 'text',
    render: 'created_datetime',
    tooltip: null,
    icon: null
  },
  {
    id: 'account_id',
    name: "廣告帳號編號",
    align: 'center',
    type: 'text',
    render: null,
    tooltip: null,
    icon: null
  },
  {
    id: 'start_date',
    name: "資料開始日期",
    align: 'center',
    type: 'text',
    render: null,
    tooltip: null,
    icon: null
  },
  {
    id: 'end_date',
    name: "資料結束日期",
    align: 'center',
    type: 'text',
    render: null,
    tooltip: null,
    icon: null
  },
  {
    id: 'job_status',
    name: "工作狀態",
    align: 'center',
    type: 'text',
    render: 'job_status',
    tooltip: null,
    icon: null
  },
  // {
  //   id: 'delete',
  //   name: "刪除",
  //   align: 'center',
  //   type: 'icon',
  //   render: null,
  //   tooltip: null,
  //   icon: 'DeleteOutlinedIcon'
  // }
]

export const tableCellDefined_client= [
  {
    id: 'created_datetime',
    name: "建立時間",
    align: 'center',
    type: 'text',
    render: 'created_datetime',
    tooltip: null,
    icon: null
  },
  {
    id: 'account_bundle.display_name',
    name: "客戶名稱",
    align: 'left',
    type: 'text',
    render: null,
    tooltip: null,
    icon: null
  },
  {
    id: 'start_date',
    name: "資料開始日期",
    align: 'center',
    type: 'text',
    render: null,
    tooltip: null,
    icon: null
  },
  {
    id: 'end_date',
    name: "資料結束日期",
    align: 'center',
    type: 'text',
    render: null,
    tooltip: null,
    icon: null
  },
  {
    id: 'job_status',
    name: "工作狀態",
    align: 'center',
    type: 'text',
    render: 'job_status',
    tooltip: null,
    icon: null
  },
  // {
  //   id: 'delete',
  //   name: "刪除",
  //   align: 'center',
  //   type: 'icon',
  //   render: null,
  //   tooltip: null,
  //   icon: 'DeleteOutlinedIcon'
  // }
]